module.exports = __webpack_public_path__ + "media/440squarec.3bca771a.wav";